import React from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ContactUs } from "./scripts/contact-us";


ReactDOM.render(
  <React.StrictMode>
    <Router basename={document.querySelector('#root').getAttribute('data-basename')}>
      <ContactUs />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);